<template>
  <div class="relative mt-20 mb-20 max-w-screen-sm left-1/2 -translate-x-1/2">
    <div class="flex flex-col flex-wrap content-center">
      <div class="px-12">
        <h2><span class="font-bold">{{ userStore.user.name }}</span>, connect your sleep data</h2>
        <p>This helps you get the best personalised recommendations 😇</p>
      </div>
      <FitbitAuthenticator
        @sync-complete="goToNext()"
      />
    </div>
  </div>
</template>

<script>
import FitbitAuthenticator from '@/components/FitbitAuthenticator'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'OnboardingImport',
  components: {
    FitbitAuthenticator,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
    goToNext() {
      this.$router.push('/onboarding/targets')
    },
  },
  computed: {
    ...mapStores(useUserStore),
  },
}
</script>